// import logo from "../../../Assets/Image/frame.png"

const Piedata=[
    {
      "id": "client1",
      "label": "client1",
      "value": 35,
      "color": "#636766"
    },
    {
      "id": "client2",
      "label": "client2",
      "value": 65,
      "color": " #13ABF4"
    },
  ]

  export default Piedata;